import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import "../OrderOptions.scss";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../../assets/i18n";

function OrderOptionsCompanyTab(props) {
    const { empresa } = props;
    const lang = useSelector(state => state.language.name)
    const pageMessages = messages[lang].orderOptions.empresa

    return (
        <Container>
            <Row>
                <Form.Group as={Col} xs={1} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.id}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={empresa.id}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.nome}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={empresa.nome}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.exigirDeclProdutor}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={empresa.exigirDeclProdutor ? 'Sim' : 'Não'}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.exigirCertSustentabilidade}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={empresa.exigirCertSustentabilidade ? 'Sim' : 'Não'}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
        </Container>
    );
}

OrderOptionsCompanyTab.propTypes = {
    empresa: PropTypes.object
};

const mapStateToProps = state => ({
    lang: state.language
});

export default connect(mapStateToProps)(OrderOptionsCompanyTab);